export default __webpack_public_path__ + "static/media/782.65e639a3.gif";